export const extraSmallParentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_250,
    height: FOUNDATIONS.size_250,
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    border_style: 'solid',
});
export const smallParentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    border_style: 'solid',
});
export const mediumParentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_325,
    height: FOUNDATIONS.size_325,
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    border_style: 'solid',
});
export const extraSmallIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_200,
    height: FOUNDATIONS.size_200,
});
export const smallIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
});
export const mediumIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_325,
    height: FOUNDATIONS.size_325,
});
//# sourceMappingURL=commonStyles.js.map